(function() {
    // 注册组件
    SR.component.extend('questionSwither', questionSwither);

    function questionSwither(questions, options) {
        if (!questions || questions.length === 0) {
            return;
        }
        questions = options.isRandom ? SR.util.shuffle(questions) : questions;
        var index = 0;
        var count = options.count || 5;
        var title = options.title || '';
        var currentQuestions = questions.slice(index * count, (index + 1) * count);
        var currentQuestionsLen = currentQuestions.length;
        var maxIndex = Math.ceil(questions.length / count);
        var animateDurationPreItem = animateDurationPreItem || 160;
        var animateDuration = animateDurationPreItem * currentQuestionsLen;
        var buttonAnimation = options.buttonAnimation || false;
        var $guideQuestions = $(options.element);
        var $title = $('<div class="title">'+ title +'</div>');
        var $questionsWrap = $('<div class="questions"></div>');
        var $animateWrap = $('<div class="q-animate-wrap"></div>');
        var $changeBtn = $('<a href="#;" class="change-btn J_changeQuestion J_analytics" data-analytics=\'{"method": "srclick", "uploadtag": 0}\'></a>').text(options.buttonText);

        if (!$guideQuestions.length) {
            console.log('CreateGuideQuestion error: can not found options.element dom');
            return;
        }

        // 启动
        this.init = function() {
            var that = this;
            $questionsWrap.append($animateWrap);
            if (title.length > 0) {
                $guideQuestions.append($title);
                $title.fadeIn();
            }
            $guideQuestions.append($questionsWrap);
            if (!buttonAnimation) {
                $questionsWrap.append($changeBtn);
            }
            this.bindChangeEvent();
            this.renderQuestions(currentQuestions);
            index += 1;
        };

        this.renderQuestions = function(questionsArr) {
            animateDuration = animateDurationPreItem * currentQuestionsLen;
            $(questionsArr).each(function(index, item) {
                var $question = $('<div class="item animate-item"><a href="#;" class="J_ask" data-option=\'{"inputType": 2}\'>' + item + '</a></div>');
                $question.css({
                    'transition-delay': '0.' + (index + 1) + 's'
                });
                $animateWrap.append($question);
                if (buttonAnimation && index === currentQuestionsLen - 1) {
                    $changeBtn.addClass('animate-item').css({
                        'transition-delay': '0.' + (index + 2) + 's'
                    });
                    $animateWrap.append($changeBtn)
                }
            });
            if (questions.length <= count) {
                $questionsWrap.find('.change-btn').remove();
            }
            setTimeout(function() {
                $animateWrap.addClass('ai-slideIn');
            }, 50);
        };

        this.clearQuestions = function(callbackHandle) {
            $animateWrap.removeClass('ai-slideIn').addClass('ai-slideOut');
            setTimeout(function() {
                $animateWrap.removeClass('ai-slideOut');
                $animateWrap.empty();
                callbackHandle && callbackHandle();
            }, animateDuration);
        };

        this.bindChangeEvent = function() {
            var that = this;
            $guideQuestions.on('click', '.J_changeQuestion', function(e) {
                e.preventDefault();
                var $me = $(this);
                if ($guideQuestions.hasClass('onChange')) {
                    return;
                }
                currentQuestions = questions.slice(index * count, (index + 1) * count);
                currentQuestionsLen = currentQuestions.length;
                pointerDuration = currentQuestionsLen * 160 * 2;
                index += 1;
                $guideQuestions.addClass('onChange');
                if (index >= maxIndex) {
                    index = 0;
                }
                that.clearQuestions(function() {
                    that.renderQuestions(currentQuestions);
                });
                setTimeout(function() {
                    $guideQuestions.removeClass('onChange');
                }, pointerDuration);
            });
        };

        this.init();
    }
}());
